import React from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { FontFamily } from '../../../constants/fonts';
import { useTheme } from '../../../theme';
import { TicketingAnalyticsTab, TicketingTabItem } from './types';

interface TicketingAnalyticsTabsProps {
  tabs: TicketingTabItem[];
  activeTab: TicketingAnalyticsTab;
  onChange: (tab: TicketingAnalyticsTab) => void;
}

const TicketingAnalyticsTabs: React.FC<TicketingAnalyticsTabsProps> = ({ tabs, activeTab, onChange }) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark' && Platform.OS !== 'web';
  return (
    <View style={[styles.tabRow, isDark && { borderBottomColor: colors.border.default }]}>
      {tabs.map((tab) => (
        <TouchableOpacity
          key={tab.key}
          style={[
            styles.tab,
            activeTab === tab.key && styles.tabActive,
            activeTab === tab.key && isDark && { borderBottomColor: colors.brand.primary },
          ]}
          onPress={() => onChange(tab.key)}
          accessibilityRole="tab"
          accessibilityState={{ selected: activeTab === tab.key }}
          testID={`tab-${tab.key}`}
        >
          <Text
            style={[
              styles.tabLabel,
              isDark && { color: colors.text.secondary },
              activeTab === tab.key && styles.tabLabelActive,
              activeTab === tab.key && isDark && { color: colors.brand.primary },
            ]}
          >
            {tab.label}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  tabRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 2,
    borderBottomColor: '#DEE3EA',
  },
  tab: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
    marginBottom: -2,
  },
  tabActive: {
    borderBottomColor: '#005CBC',
  },
  tabLabel: {
    fontSize: 14,
    fontFamily: FontFamily.medium,
    color: '#5D636B',
  },
  tabLabelActive: {
    fontFamily: FontFamily.bold,
    color: '#005CBC',
  },
});

export default TicketingAnalyticsTabs;






